import "./App.css";
import Dashboard from "./components/dashboard/Dashboard";

function App() {
  return (
    <div className="bg-gray-50 min-h-screen h-full">
      <Dashboard />
    </div>
  );
}

export default App;
